import React from "react";
import { Input } from "@/components/ui/input";

const PRESETS = [
  ["today", "Today"], ["7d", "Last 7 days"], ["30d", "Last 30 days"],
  ["90d", "Last 90 days"], ["all", "All time"], ["custom", "Custom"],
];

export function DateRangeFilter({ value, onChange, loading = false }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-3 mb-8 flex flex-wrap items-center gap-2" data-testid="analytics-date-filter">
      {PRESETS.map(([key, label]) => (
        <button
          key={key}
          type="button"
          onClick={() => set({ preset: key })}
          data-testid={`date-preset-${key}`}
          className={`px-3 py-1.5 rounded-full text-xs font-bold transition-colors ${
            value.preset === key ? "bg-[#0A2540] text-white" : "bg-slate-50 text-slate-600 hover:bg-slate-100"
          }`}
        >
          {label}
        </button>
      ))}
      {value.preset === "custom" && (
        <div className="flex items-center gap-2 ml-2" data-testid="date-custom-inputs">
          <Input type="date" value={value.from || ""} onChange={(e) => set({ from: e.target.value })} className="h-8 w-40 text-xs" data-testid="date-from" />
          <span className="text-xs text-slate-400">to</span>
          <Input type="date" value={value.to || ""} onChange={(e) => set({ to: e.target.value })} className="h-8 w-40 text-xs" data-testid="date-to" />
        </div>
      )}
      <span className="ml-auto text-[11px] text-slate-400" data-testid="date-filter-note">
        {loading ? <span className="text-[#0A2540] font-bold" data-testid="date-filter-loading">Updating…</span> : "Booking date · IST"}
      </span>
    </div>
  );
}
